<template>
  <el-dialog
    title="编辑采收记录"
    :visible.sync="visible"
    width="1100px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <div class="order-edit-form">
      <el-form :model="form" :rules="rules" ref="orderForm" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="采收日期" prop="harvestDate" required>
              <el-date-picker
                v-model="form.harvestDate"
                type="date"
                placeholder="请选择采收日期"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="基地/大棚" prop="greenhouseId" required>
              <el-select
                v-model="form.greenhouseId"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option
                  v-for="item in greenhouseOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="草莓品种" prop="varietyId" required>
              <el-select
                v-model="form.varietyId"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option
                  v-for="opt in varietyOptions"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-top: 8px">
          <el-col :span="8">
            <el-form-item label="采收负责人" prop="harvestManagerId" required>
              <el-select
                v-model="form.harvestManagerId"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option
                  v-for="opt in harvestManagerOptions"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="采收总量(kg)" prop="sumWeight">
              <el-input-number
                v-model="form.sumWeight"
                :min="1"
                :controls="false"
                :precision="3"
                style="width: 100%"
                :step="0.1"
              />
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="仓储位置" prop="basicStorageId">
              <el-select
                v-model="form.basicStorageId"
                placeholder="请选择"
                filterable
                clearable
              >
                <el-option
                  v-for="opt in storageOptions"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-top: 8px">
          <el-col :span="24">
            <el-form-item label="采收图片" prop="attachment">
              <ImageUpload v-model="form.attachment" :maxCount="3" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item
          label="审核记录"
          v-if="Array.isArray(form.reviewLogList) && form.reviewLogList.length"
        >
          <el-table
            :data="form.reviewLogList"
            border
            size="small"
            style="width: 100%"
          >
            <el-table-column prop="reviewer" label="审核人" width="160" />
            <el-table-column prop="reviewMsg" label="审核意见" />
            <el-table-column prop="reviewTime" label="审核时间" width="160">
              <template slot-scope="{ row }">{{
                formatDate(row.reviewTime)
              }}</template>
            </el-table-column>
            <el-table-column prop="packaged" label="交付包装" width="100">
              <template slot-scope="{ row }">{{
                row.packaged ? "是" : "否"
              }}</template>
            </el-table-column>
            <el-table-column prop="deliveryDate" label="交付日期" width="120">
              <template slot-scope="{ row }">{{
                formatDate(row.deliveryDate)
              }}</template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="submit(false)">确定</el-button>
      <el-button type="primary" plain @click="submit(true)">暂存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";
import ImageUpload from "@/components/ImageUpload.vue";
import dayjs from "dayjs";

export default {
  name: "OrderEditDialog",
  components: {
    ImageUpload,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: "",
    },
    greenhouseOptions: {
      type: Array,
      default: () => [],
    },
    harvestManagerOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        id: "",
        isDraft: false,
        harvestDate: null,
        greenhouseId: "",
        varietyId: "",
        harvestManagerId: "",
        sumWeight: null,
        basicStorageId: "",
        attachment: [],
      },
      varietyOptions: [],
      storageOptions: [],
      rules: {
        harvestDate: [
          { required: true, message: "请选择采收日期", trigger: "change" },
        ],
        greenhouseId: [
          { required: true, message: "请选择大棚", trigger: "change" },
        ],
        varietyId: [
          { required: true, message: "请选择草莓品种", trigger: "change" },
        ],
        harvestManagerId: [
          { required: true, message: "请选择采收负责人", trigger: "change" },
        ],
        sumWeight: [
          { required: true, message: "请输入采收重量", trigger: "change" },
        ],
      },
    };
  },
  watch: {
    visible(val) {
      if (val && this.orderId) {
        this.fetchOrderDetail();
        this.fetchVarietyOptions();
        this.fetchStorageOptions();
      } else {
        // reset form when closed
        this.resetForm();
      }
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "-";
      try {
        return dayjs(date).format("YYYY-MM-DD");
      } catch (e) {
        return date;
      }
    },
    resetForm() {
      this.form = {
        id: "",
        isDraft: false,
        harvestDate: null,
        greenhouseId: "",
        varietyId: "",
        harvestManagerId: "",
        sumWeight: null,
        basicStorageId: "",
        attachment: [],
      };
      if (this.$refs.orderForm) {
        this.$refs.orderForm.clearValidate();
      }
    },
    async fetchOrderDetail() {
      try {
        const res = await axios.post(
          baseUrl + "/api/digital-farming/harvest/order-detail/" + this.orderId
        );
        if (res && res.code === 200 && res.data) {
          const data = res.data;
          this.form = {
            id: data.id,
            harvestDate: data.harvestDate
              ? dayjs(data.harvestDate).toDate()
              : null,
            greenhouseId: data.greenhouseId,
            varietyId: data.varietyId,
            harvestManagerId: data.harvestManagerId,
            sumWeight: data.sumWeight,
            reviewLogList: data.reviewLogList,
            basicStorageId: data.basicStorageId,
            attachment: Array.isArray(data.attachment) ? data.attachment : [],
          };
        }
      } catch (error) {
        console.error("获取采收单详情失败:", error);
        this.$message &&
          this.$message.error &&
          this.$message.error("获取数据失败，请重试");
      }
    },
    async fetchVarietyOptions() {
      try {
        const res = await axios.post(
          baseUrl + "/api/basic/strawberry-variety/selection"
        );
        console.log("草莓品种", res);

        if (res && res.code === 200) {
          this.varietyOptions = res.data.map((it) => ({
            label: it.varietyName,
            value: it.id,
          }));
        }
      } catch (e) {
        console.error("fetchVarietyOptions error:", e);
      }
    },
    async fetchStorageOptions() {
      try {
        const res = await axios.post(
          baseUrl + "/api/basic/storage-location/selection",
          { enableStatus: true }
        );
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.storageOptions = res.data.map((it) => ({
            label: it.storageName,
            value: it.id,
          }));
        }
      } catch (e) {
        console.error("fetchStorageOptions error:", e);
      }
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
    async submit(isDraft) {
      this.form.isDraft = !!isDraft;
      // validate required fields
      this.$refs.orderForm.validate(async (valid) => {
        if (!valid) return;

        // 获取对应的名称
        const selectedGreenhouse = this.greenhouseOptions.find(
          (item) => item.value === this.form.greenhouseId
        );
        const selectedHarvestManager = this.harvestManagerOptions.find(
          (item) => item.value === this.form.harvestManagerId
        );
        const selectedVariety = this.varietyOptions.find(
          (item) => item.value === this.form.varietyId
        );

        const payload = {
          id: this.form.id,
          isDraft: this.form.isDraft,
          harvestDate: dayjs(this.form.harvestDate).format("YYYY-MM-DD"),
          greenhouseId: this.form.greenhouseId,
          greenhouseName: selectedGreenhouse ? selectedGreenhouse.label : "",
          varietyId: this.form.varietyId,
          varietyName: selectedVariety ? selectedVariety.label : "",
          harvestManagerId: this.form.harvestManagerId,
          harvestManager: selectedHarvestManager
            ? selectedHarvestManager.label
            : "",
          sumWeight: this.form.sumWeight,
          basicStorageId: this.form.basicStorageId,
          attachment: Array.isArray(this.form.attachment)
            ? this.form.attachment
            : [],
        };

        try {
          const res = await axios.post(
            baseUrl + "/api/digital-farming/harvest/edit-order",
            payload
          );
          if (res && res.code === 200) {
            this.$message &&
              this.$message.success &&
              this.$message.success("编辑成功");
            this.$emit("success");
            this.handleClose();
          } else {
            this.$message &&
              this.$message.error &&
              this.$message.error(
                res && res.message ? res.message : "编辑失败"
              );
          }
        } catch (err) {
          console.error("edit-order error:", err);
          this.$message &&
            this.$message.error &&
            this.$message.error("编辑失败");
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.order-edit-form {
  .el-form-item {
    margin-bottom: 12px;
  }
}
</style>
